// Copied from nyceBuddy3 chat-ui report/format.ts (only the helpers the UI primitives use).
export const isNum = (v: unknown): v is number => typeof v === 'number' && Number.isFinite(v);

export const fmt = (v: unknown, digits = 2): string =>
  !isNum(v)
    ? ''
    : Number.isInteger(v)
      ? v.toLocaleString()
      : v.toLocaleString(undefined, { maximumFractionDigits: digits });

/** Cell text for tables/CSV: null → '', numbers localised, interval objects `{days,hours,...}` compacted, others JSON. */
export function cellText(v: unknown, locale = true): string {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number') return locale ? fmt(v, 4) : String(v);
  if (typeof v === 'boolean') return v ? 'true' : 'false';
  if (v instanceof Date) return v.toISOString();
  if (Array.isArray(v)) return JSON.stringify(v);
  if (typeof v === 'object') {
    const o = v as Record<string, unknown>;
    if ('days' in o || 'hours' in o || 'minutes' in o || 'seconds' in o) {
      const parts: string[] = [];
      if (o.days) parts.push(`${o.days}d`);
      if (o.hours) parts.push(`${o.hours}h`);
      if (o.minutes) parts.push(`${o.minutes}m`);
      if (o.seconds) parts.push(`${o.seconds}s`);
      if (o.milliseconds) parts.push(`${o.milliseconds}ms`);
      return parts.join(' ') || '0';
    }
    try {
      return JSON.stringify(v);
    } catch {
      return String(v);
    }
  }
  return String(v);
}

export const columnsOf = (rows: Record<string, unknown>[], explicit?: string[]): string[] =>
  explicit && explicit.length ? explicit : [...new Set(rows.flatMap((r) => Object.keys(r ?? {})))];

/** Compare for sorting: nulls last, numbers numerically, strings with numeric collation. */
export function compareCells(x: unknown, y: unknown): number {
  if (x == null && y == null) return 0;
  if (x == null) return 1;
  if (y == null) return -1;
  if (typeof x === 'number' && typeof y === 'number') return x - y;
  return String(x).localeCompare(String(y), undefined, { numeric: true, sensitivity: 'base' });
}
